// extracted by mini-css-extract-plugin
export var notFound = "_404-module--notFound--U3+A1";
export var redLine = "_404-module--redLine--6OEY6";
export var route = "_404-module--route--2Rg8M";
export var wrapper = "_404-module--wrapper--y1mXV";